import { useContext } from 'react'
import { UserDeliveryPostcodeContext } from '~/providers'

export const useUserDeliveryPostcode = () => {
  return useContext(UserDeliveryPostcodeContext)
}
